import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { resolveShellRedirect, SHELL_PREFERENCE_STORAGE_KEY, type ShellPreference } from "./device-routing";

function storedShellPreference(): ShellPreference {
  try {
    const value = window.localStorage.getItem(SHELL_PREFERENCE_STORAGE_KEY);
    return value === "mobile" || value === "desktop" ? value : null;
  } catch {
    return null;
  }
}

export function setShellPreference(value: Exclude<ShellPreference, null>): void {
  try {
    window.localStorage.setItem(SHELL_PREFERENCE_STORAGE_KEY, value);
  } catch {
    /* private mode: preference just won't persist */
  }
}

/**
 * Mounted once near the app root. Redirects between /admin and /m based on
 * device heuristics and the user's explicit shell preference. Depends only
 * on the pure device-routing module so it stays out of heavier shell code
 * in the main bundle.
 */
export function MobileShellRedirectGate() {
  const location = useLocation();
  const target = useMemo(
    () => resolveShellRedirect({
      pathname: location.pathname,
      userAgent: window.navigator.userAgent,
      viewportWidth: window.innerWidth,
      preference: storedShellPreference(),
    }),
    [location.pathname],
  );
  if (target) return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
  return null;
}
